import { StoreFeature } from "../../../core/store/types";

export type Fields = string[];

export const fields: StoreFeature<Fields> =
{
    getPostData: (state: Fields, store) =>
    {
        return {
            dataSourceFields: JSON.stringify(state),
            dataSourceFieldsHash: store.hashes["fields"],
        };
    }
};